import { clampTo, hasImageInput } from '../../tools';
import type { KieModelConfig } from '../types';

export const bytedanceConfigs: Record<string, KieModelConfig> = {
    'seedream-v5.0-pro': {
        // https://docs.kie.ai/cn/market/seedream/5-pro-text-to-image
        // https://docs.kie.ai/cn/market/seedream/5-pro-image-to-image
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'seedream/5-pro-image-to-image',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        aspect_ratio: aspectRatio === 'match'
                            ? '16:9'
                            : clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                        quality: (image_resolution || '1K').toUpperCase() === '2K' ? 'high' : 'basic',
                        // 图片 URL
                        image_urls: image_urls!.slice(0, 10),
                        // 可选参数
                        output_format: clampTo(
                            providerOptions?.output_format || 'png',
                            ['png', 'jpeg'] as const,
                            'png',
                        ),
                        // system
                        nsfw_checker: false,
                    },
                };
            }
            return {
                model: 'seedream/5-pro-text-to-image',
                input: {
                    prompt: prompt.slice(0, 5000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                    quality: (image_resolution || '1K').toUpperCase() === '2K' ? 'high' : 'basic',
                    // 可选参数
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg'] as const,
                        'png',
                    ),
                    // system
                    nsfw_checker: false,
                },
            };
        },
    },
    'seedream-v5.0-flash': {
        // https://kie.ai/seedream-5-0-flash?model=seedream%2F5-flash-text-to-image
        // https://kie.ai/seedream-5-0-flash?model=seedream%2F5-flash-image-to-image
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'seedream/5-flash-image-to-image',
                    input: {
                        prompt: prompt.slice(0, 5000),
                        aspect_ratio: aspectRatio === 'match'
                            ? '16:9'
                            : clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                        quality: (image_resolution || '1K').toUpperCase() === '2K' ? 'high' : 'basic',
                        // 图片 URL
                        image_urls: image_urls!.slice(0, 10),
                        // 可选参数
                        output_format: clampTo(
                            providerOptions?.output_format || 'png',
                            ['png', 'jpeg'] as const,
                            'png',
                        ),
                        // system
                        nsfw_checker: false,
                    },
                };
            }
            return {
                model: 'seedream/5-flash-text-to-image',
                input: {
                    prompt: prompt.slice(0, 5000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                    quality: (image_resolution || '1K').toUpperCase() === '2K' ? 'high' : 'basic',
                    // 可选参数
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg'] as const,
                        'png',
                    ),
                    // system
                    nsfw_checker: false,
                },
            };
        },
    },
    'seedream-v5.0-lite': {
        // https://docs.kie.ai/cn/market/seedream/5-lite-text-to-image
        // https://docs.kie.ai/cn/market/seedream/5-lite-image-to-image
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'seedream/5-lite-image-to-image',
                    input: {
                        prompt: prompt.slice(0, 3000),
                        aspect_ratio: aspectRatio === 'match'
                            ? '16:9'
                            : clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                        quality: (image_resolution || '2K').toUpperCase() === '4K'
                            ? 'ultra'
                            : (image_resolution || '2K').toUpperCase() === '3K'
                                ? 'high'
                                : 'basic',
                        // 图片 URL
                        image_urls: image_urls!.slice(0, 14),
                        // 可选参数
                        output_format: clampTo(
                            providerOptions?.output_format || 'png',
                            ['png', 'jpeg'] as const,
                            'png',
                        ),
                        // system
                        nsfw_checker: false,
                    },
                };
            }
            return {
                model: 'seedream/5-lite-text-to-image',
                input: {
                    prompt: prompt.slice(0, 3000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                    quality: (image_resolution || '2K').toUpperCase() === '4K'
                        ? 'ultra'
                        : (image_resolution || '2K').toUpperCase() === '3K'
                            ? 'high'
                            : 'basic',
                    // 可选参数
                    output_format: clampTo(
                        providerOptions?.output_format || 'png',
                        ['png', 'jpeg'] as const,
                        'png',
                    ),
                    // system
                    nsfw_checker: false,
                },
            };
        },
    },
    'seedream-v4.5': {
        // https://docs.kie.ai/cn/market/seedream/4-5-text-to-image
        // https://docs.kie.ai/cn/market/seedream/4-5-edit
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'seedream/4.5-edit',
                    input: {
                        prompt: prompt.slice(0, 3000),
                        aspect_ratio: aspectRatio === 'match'
                            ? '16:9'
                            : clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                        quality: (image_resolution || '2K').toUpperCase() === '4K' ? 'high' : 'basic',
                        // 图片 URL
                        image_urls: image_urls!.slice(0, 14),
                        // system
                        nsfw_checker: false,
                    },
                };
            }
            return {
                model: 'seedream/4.5-text-to-image',
                input: {
                    prompt: prompt.slice(0, 3000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['1:1', '4:3', '3:4', '16:9', '9:16', '2:3', '3:2', '21:9'] as const, '16:9'),
                    quality: (image_resolution || '2K').toUpperCase() === '4K' ? 'high' : 'basic',
                    // system
                    nsfw_checker: false,
                },
            };
        },
    },
};